import EmptyPlaceholder from 'components/EmptyPlaceholder/EmptyPlaceholder';
import { AutoSizer } from 'react-virtualized';
import { FixedSizeList as List } from "react-window";
import WorkOrderCard from "../../WorkorderDashboard/WorkOrderCard/WorkOrderCard";

const ActivityListConfirm = ({ entities }) => {

    const Row = ({ index, style }) => (
        <div style={style}>
            <WorkOrderCard
                entity={entities?.[index]}
                handleDone={() => { }}
                key={index}
            />
        </div>
    );

    return (
        <>
            {!!entities?.length ?
                <div style={{ flex: 1, height: '100%' }}>
                    <AutoSizer>
                        {({ height, width }) => (
                            <List
                                className="List"
                                height={height}
                                itemCount={entities?.length}
                                itemSize={215}
                                width={width}
                            >
                                {Row}
                            </List>
                        )}
                    </AutoSizer>
                </div>
                : <EmptyPlaceholder text='There are no activities or loads matching this criteria' />
            }
        </>
    )
}

export default ActivityListConfirm;